import { Box } from '@mui/joy'
import { useIsAppControl } from '@store/isApp'
import pxToRem from '@utils/pxToRem'
import setAds from '@utils/setAds'
import { useLayoutEffect } from 'react'

type ArticleAsideAdSize = 'xl' | 'lg'
type ArticleAsideAdProps = {
	size: ArticleAsideAdSize
	index: number
}
const adList: {
	[key: string]: Array<{
		id: string
		inventory: string
	}>
} = {
	xl: [
		{
			id: '6U8OkHFERRuJT84iMZQAIg',
			inventory: 'jtbc_p/article_news/article_news@article_news_top_right_300x250?mlink=571',
		},
		{
			id: '1P6tgFgPQdqr4EjWoHy5Yw',
			inventory:
				'jtbc_p/article_news/article_news@article_news_midtop_right_300x250?mlink=572',
		},
		{
			id: 'QQAChxygSUCRje0JL3N_0w',
			inventory:
				'jtbc_p/article_news/article_news@article_news_midbottom_right_300x250?mlink=573',
		},
		{
			id: 'P9NbUFqVR8eltsiube9wQA',
			inventory:
				'jtbc_p/article_news/article_news@article_news_bottom_right_300x250?mlink=574',
		},
	],
	lg: [
		{
			id: '24G0cyESSeW0j1BTjWUQ5Q',
			inventory: 'jtbc_p/article_news/article_news@article_news_top_right_200x200?mlink=610',
		},
		{
			id: '36hLbFBhTLWUvBzOEDag8Q',
			inventory:
				'jtbc_p/article_news/article_news@article_news_midtop_right_200x200?mlink=611',
		},
		{
			id: 'ciwexZKWQ3K0cCjlHuzxqQ',
			inventory:
				'jtbc_p/article_news/article_news@article_news_midbottom_right_200x200?mlink=612',
		},
		{
			id: '56eA0ddBSAarMCt2UWiZEA',
			inventory:
				'jtbc_p/article_news/article_news@article_news_bottom_right_200x200?mlink=613',
		},
	],
}
const ArticleAsideAd = ({ size, index }: ArticleAsideAdProps) => {
	const { isApp } = useIsAppControl()
	const { id, inventory } = adList[size][index]
	useLayoutEffect(() => {
		if (!isApp) {
			setAds({ id, inventory })
		}
	}, [isApp])
	return (
		!isApp && (
			<Box
				display={{
					xs: 'none',
					lg: size === 'lg' ? 'block' : 'none',
					xl: size === 'xl' ? 'block' : 'none',
				}}
				width={{
					lg: pxToRem(200),
					xl: pxToRem(300),
				}}
				height={{
					lg: pxToRem(200),
					xl: pxToRem(250),
				}}
				id={`${id}_AD`}
			/>
		)
	)
}
export default ArticleAsideAd
